import { EstadoEmpresaAgentesEnum } from "@/.shared/.api";

/** Autoregistro con empresa validada o pendiente de firma: campos de identidad y documentación inmutables. */
export function isEmpresaAgentesInmutable(
  idEstado: string | null | undefined,
  autoregistro: boolean | undefined,
): boolean {
  if (!autoregistro) {
    return false;
  }
  return (
    idEstado === EstadoEmpresaAgentesEnum.Validada
    || idEstado === EstadoEmpresaAgentesEnum.PdtFirma
  );
}
